
import Component, { mixins } from "vue-class-component"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import KundendatenLogic from "@/logic/bestellung_neu/kundendaten_logic"
import Calculator from "../mixins/Calculator.vue"
import { LoadState } from "mangdto"

@Component({ components: { FilialeHeader, NichtGueltig } })
export default class Kundendaten extends mixins(Calculator) {
  $refs!: {
    form: HTMLFormElement
  }

  logic: KundendatenLogic = new KundendatenLogic()

  LoadState = LoadState

  weiter() {
    var valid = this.$refs.form.validate()

    if (!valid) return

    this.logic.weiter()
  }

  mounted() {
    this.logic = new KundendatenLogic()
    this.logic.init()
  }
}
